var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalicBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.30823L12 2.30823M1.69116 17.1667H9.19116",
    stroke: "black",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88192 2.95455L6.46715 17.5H4.70579L7.12056 2.95455H8.88192Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicBlack);
export default __webpack_public_path__ + "static/media/Italic_Black.13e9a63209669bb374d3f25c2a952b24.svg";
export { ForwardRef as ReactComponent };